import { createBrowserRouter, Navigate } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout';
import LoginPage from './auth/LoginPage';
import SignUpPage from './auth/SignUpPage';
import ProductsPage from './auth/ProductsPage';

const authRoutes = createBrowserRouter([
  {
    path: 'auth',
    element: undefined,//<AuthLayout />,
    children: [
      { path: 'login', element: <LoginPage />, index: true },
      { path: 'signup', element: <SignUpPage /> },
      { path: 'products', element: <ProductsPage /> },
    ]
  },
  {
    path: '*',
    element: <Navigate to='/auth/login' />
  }
]);

export default authRoutes;